import { Provider } from "@angular/core";
import { APP_CONFIG, IAppConfiguration } from "@bca-shared/models/config";

export function appConfigurationFactory(): IAppConfiguration {
  return {
    ...window.config,
  };
}

export function provideAppConfiguration(): Provider {
  return {
    provide: APP_CONFIG,
    useFactory: appConfigurationFactory,
  };
}
